/**
 * High level router.
 *
 * Note: It's recommended to compose related routes in internal router
 * components (e.g: `src/app/modules/Auth/pages/AuthPage`, `src/app/BasePage`).
 */

import { FC } from 'react'
import { Routes, Route, BrowserRouter, Navigate } from 'react-router-dom'
import AdminRoutes from '@/projects/admin/admin-routes'
import { ErrorsPage } from '@/modules/errors/ErrorsPage'
import { AuthPage, useAuth } from '@/modules/auth'
import { App } from '@/App'
import SyncflowRoutes from '@/projects/syncflow/syncflow-routes'
import { useThemeContext, ThemeContext } from '../themes/theme';
import PlatformRoutes from './projects/platform/platform-routes'
import B2bRoutes from './projects/b2b/b2b-routes'


const { BASE_URL } = import.meta.env

const RouteProvider: FC = () => {
  const themeContext = useThemeContext();
  const { currentUser } = useAuth()
  return (
    <ThemeContext.Provider value={themeContext}>
      <BrowserRouter basename={BASE_URL}>
        <Routes>
          <Route element={<App />}>
            <Route path='error/*' element={<ErrorsPage />} />
            {currentUser ? (
              <>
                <Route path='login/*' element={<Navigate to='/' />} />
                <Route path='/syncflow/*' element={<SyncflowRoutes />} />
                <Route path='/b2b/*' element={<B2bRoutes />} />
                <Route path='/admin/*' element={<AdminRoutes />} />
                {<Route path='/*' element={<PlatformRoutes />} />}
                <Route index element={<Navigate to='/home' />} />
              </>
            ) : (
              <>
                <Route path='login/*' element={<AuthPage />} />
                <Route path='*' element={<Navigate to='/login' />} />
              </>
            )}
          </Route>
        </Routes>
      </BrowserRouter>
    </ThemeContext.Provider>
  )
}

export { RouteProvider }
